import Web3 from "web3";

export const shortenAddress = (address) => {
    return `${address.substring(0, 8)}...${address.substring(address.length - 6)}`
}

export function loadContract(provider, abi, address) {
    const web3 = new Web3(provider)
    return new web3.eth.Contract(abi, address)
}